export const statsSet = 180;
export const allPatches = [
  16220, 16212, 16210, 16201, 16200, 16191, 16190, 16181, 16180, 16173, 16170,
];
export const lastPatch = allPatches[0];
export const REVIQ_THRESHOLD = -1;
// TMP: Push for rebuild 2
